/**
 * Permit Permission Hooks
 * ✅ RETIRED 2026-05-01 (PR-F2): ENABLE_PERMIT_TAB + ENABLE_PERMIT_SHARE flags removed
 * Uses dedicated PERMIT_* permissions with AND logic (permission + project access)
 */

import { useConsolidatedPermissions } from '@/hooks/useConsolidatedPermissions';

/**
 * Check if user can VIEW Permit tab
 * Requires: PERMIT_VIEW permission + project can_view (checked via RLS)
 */
export const usePermitAccess = () => {
  const { data: permissions, isLoading } = useConsolidatedPermissions();
  
  return {
    data: permissions?.isAdmin || permissions?.PERMIT_VIEW,
    isLoading,
  };
};

/**
 * Check if user can CREATE permits (upload, create sections)
 * Requires: PERMIT_CREATE permission + project can_edit (checked via RLS)
 */
export const usePermitCreateAccess = () => {
  const { data: permissions, isLoading } = useConsolidatedPermissions();
  
  return {
    data: permissions?.isAdmin || permissions?.PERMIT_CREATE,
    isLoading,
  };
};

/**
 * Check if user can EDIT permits (inline edit, update)
 * Requires: PERMIT_EDIT permission + project can_edit (checked via RLS)
 */
export const usePermitEditAccess = () => {
  const { data: permissions, isLoading } = useConsolidatedPermissions();
  
  return {
    data: permissions?.isAdmin || permissions?.PERMIT_EDIT,
    isLoading,
  };
};

/**
 * Check if user can DELETE permits
 * Requires: PERMIT_DELETE permission + project can_delete (checked via RLS)
 */
export const usePermitDeleteAccess = () => {
  const { data: permissions, isLoading } = useConsolidatedPermissions();
  
  return {
    data: permissions?.isAdmin || permissions?.PERMIT_DELETE,
    isLoading,
  };
};

/**
 * Check if user can SHARE permits (create/manage share links)
 * Requires: PERMIT_SHARE permission
 */
export const usePermitShareAccess = () => {
  const { data: permissions, isLoading } = useConsolidatedPermissions();
  
  return {
    data: permissions?.isAdmin || permissions?.PERMIT_SHARE,
    isLoading,
  };
};

/**
 * Combined hook for all permit permissions
 * Use this when you need multiple permission checks in one component
 */
export const usePermitPermissions = () => {
  const { data: permissions, isLoading } = useConsolidatedPermissions();
  
  const isAdmin = permissions?.isAdmin || false;
  
  return {
    canView: isAdmin || permissions?.PERMIT_VIEW,
    canCreate: isAdmin || permissions?.PERMIT_CREATE,
    canEdit: isAdmin || permissions?.PERMIT_EDIT,
    canDelete: isAdmin || permissions?.PERMIT_DELETE,
    canShare: isAdmin || permissions?.PERMIT_SHARE,
    isLoading,
    isAdmin,
  };
};

/**
 * @deprecated Use usePermitPermissions instead
 * Legacy hook for manage access - kept for backwards compatibility
 */
export const usePermitManageAccess = () => {
  const { canCreate, canEdit, isLoading } = usePermitPermissions();
  
  return {
    data: canCreate || canEdit,
    isLoading,
  };
};
